import axios from "axios";
import { DTODataScienceSearchProductsResponse, DTODataScienceSearchCustomersResponse } from "./dto";

export const getDataScienceSearchCustomer = async (
  searchQuery: string,
  searchAfter: string | null
): Promise<DTODataScienceSearchCustomersResponse> => {
  const queryParams = new URLSearchParams({ query: searchQuery });

  if (searchAfter) {
    queryParams.append("search_after", searchAfter);
  }

  const url = `/data-science-search/customers?${queryParams.toString()}`;
  const { data } = await axios.get<DTODataScienceSearchCustomersResponse>(url);

  return data;
};

export const getDataScienceSearchProducts = async (
  searchQuery: string,
  searchAfter: string | null
): Promise<DTODataScienceSearchProductsResponse> => {
  const queryParams = new URLSearchParams({ query: searchQuery });

  if (searchAfter) {
    queryParams.append("search_after", searchAfter);
  }

  const url = `/data-science-search/products?${queryParams.toString()}`;
  const { data } = await axios.get<DTODataScienceSearchProductsResponse>(url);

  return data;
};
